import styled from 'styled-components';
import BlobComponent from './BlobComponent';
import { GrainyBackgroundContainer } from './GrainyBackground.styles';

// Defined once at module level: a styled component created inside render remounts the blobs on every render
const BlobWrapper = styled.div`
  will-change: transform;

  &.big-east-north-west {
  animation: bigEastNorthWest 8s infinite ease-in-out;
  }
  &.big-east-north {
  animation: bigEastNorth 8s infinite ease-in-out;
  }

  @keyframes bigEastNorthWest {
  0% {
      transform: translate(0, 0);
  }
  50% {
      transform: translate(-200px, 200px); /* Larger movement for 700px blob */
  }
  75% {
      transform: translate(100px, -100px); /* Larger movement for 700px blob */
  }
  100% {
      transform: translate(-0px, 0px); /* Larger movement */
  }
  }

  @keyframes bigEastNorth {
  0% {
      transform: translate(0, 0);
  }
  50% {
      transform: translate(200px, -200px); /* Adjusted for east-north direction */
  }
  75% {
      transform: translate(100px, -100px); /* Larger movement for 700px blob */
  }
  100% {
      transform: translate(-0px, 0px); /* Return to start */
  }
  }

  @media (prefers-reduced-motion: reduce) {
    &.big-east-north-west,
    &.big-east-north {
      animation: none;
    }
  }
`;

const GrainyBackground = ({ className } = {}) => {

  const userBlobColors=['#FFCADC', '#C4AFCF']
  const getBlobColor = index => {
    return userBlobColors?.[index];
  };


  return (
    <GrainyBackgroundContainer className={className}>
      <div className='blob-cont'>
      <BlobWrapper className="big-east-north-west">
        <BlobComponent
            color={getBlobColor(1)}
            position={{
                top: '-100px',
                left: '300px',
                height: '700px',
                width: '700px',
            }}
            />
        </BlobWrapper>
        <BlobWrapper className="big-east-north">
          <BlobComponent
            color={getBlobColor(0)}
            position={{
                top: '300px',
                right: '300px',
                height: '700px',
                width: '700px',
            }}
            />
        </BlobWrapper>
      </div>
    </GrainyBackgroundContainer>
  );
};

export default GrainyBackground;
